import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import PropTypes from 'prop-types';
import React from 'react';
import {
  useAccordionListStateContext,
} from './AccordionListContext';
import { useSortOnClick } from './hooks';

const AccordionHeaderColumn = ({
  orderable,
  attrName,
  className,
  children: childrenProp,
  ...rest
}) => {
  const { order } = useAccordionListStateContext();
  const onClick = useSortOnClick(attrName, orderable);

  let Icon = null;

  const isSelected = orderable && order.attrName === attrName;
  if (isSelected) {
    Icon = order.direction === 'asc' ? (
      <ArrowUpwardIcon fontSize="small" color="primary" />
    ) : (
      <ArrowDownwardIcon fontSize="small" color="primary" />
    );
  }
  return (
    <div // eslint-disable-line jsx-a11y/click-events-have-key-events
      tabIndex="-1"
      role="button"
      style={orderable ? {
        cursor: 'pointer',
      } : {}}
      className={className}
      onClick={onClick}
      {...rest}
    >
      {childrenProp}
      {Icon}
    </div>
  );
};

AccordionHeaderColumn.defaultProps = {
  orderable: false,
  attrName: null,
};

AccordionHeaderColumn.propTypes = {
  className: PropTypes.string.isRequired,
  orderable: PropTypes.bool,
  attrName: PropTypes.string,
  children: PropTypes.any.isRequired,
};

export default AccordionHeaderColumn;
